import { NgModule } from '@angular/core';
import { SchemaConnectorComponent} from './schema-connector.component'
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';  
@NgModule({
    imports: [ FormsModule,CommonModule],
    declarations: [
        // EnvironmentItemComponent,
        SchemaConnectorComponent
    ],
    entryComponents: [
        SchemaConnectorComponent
    ],
    exports: [
        SchemaConnectorComponent
    ]
})
export class SchemaConnectorModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/schema-connector/schema-connector.module.ts